module.exports = __webpack_public_path__ + "va.svg?a44c6ba981a68dc7e9cd12f0c07c3e9a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/va.svg
// module id = 1681
// module chunks = 0